import {
    type FC,
    type PropsWithChildren,
    type RefObject,
    useEffect,
    useState,
} from "react";
import { UIContext, useUISettings } from "@onshopfront/components";

export const UIScrollProvider: FC<PropsWithChildren<{
    ref: RefObject<Element | null>;
}>> = ({ ref, children }) => {
    const oldUIContext = useUISettings();

    const [ uiContext, setUIContext ] = useState(oldUIContext);

    useEffect(() => {
        setUIContext({
            ...oldUIContext,
            scrollBody: ref.current ?? oldUIContext.scrollBody,
        });
    }, [ oldUIContext, ref ]);

    return (
        <UIContext.Provider value={uiContext}>
            {children}
        </UIContext.Provider>
    );
};
